import { TEXTOS } from '../../manual-textos';
import { itensValidos, ou } from '../../manual-utils';
import {
  blocoAlerta,
  blocoCapitulo,
  blocoLista,
  blocoSecao,
  blocoTabela,
  blocoTexto,
} from '../blocos';
import type { Bloco } from '../blocos';
import type { ManualData } from '../../manual-types';

export function capitulo6(dados: ManualData): Bloco[] {
  const blocos: Bloco[] = [blocoCapitulo(6, 'Manutenção, limpeza e ajuste')];
  blocos.push(...blocoTexto(dados.orientacaoManutencao || TEXTOS.manutencaoIntro, 'c6-intro'));
  blocos.push(blocoAlerta({
    tipo: 'obrigatorio',
    titulo: 'AÇÃO OBRIGATÓRIA',
    texto: 'Bloqueie e etiquete todas as fontes de energia antes de iniciar qualquer atividade de manutenção, limpeza ou ajuste.',
  }, 'c6-alerta'));

  blocos.push(blocoSecao('6.1', 'Plano de manutenção'));
  const plano = itensValidos(dados.planoManutencao, ['parte', 'tarefa', 'metodo']);
  blocos.push(...blocoTabela({
    id: 'c6-plano',
    legenda: 'PLANO DE MANUTENÇÃO PREVENTIVA',
    colunas: ['PARTE / CONJUNTO', 'TAREFA', 'MÉTODO', 'PERIODICIDADE', 'RESPONSÁVEL'],
    linhas: plano.map((item) => [ou(item.parte, '—'), ou(item.tarefa, '—'), ou(item.metodo, '—'), ou(item.periodicidade, '—'), ou(item.responsavel, '—')]),
    variante: 'plano',
    larguras: ['20%', '24%', '26%', '16%', '14%'],
    alinharEsquerda: true,
    porPagina: 14,
  }));

  let proxima = 2;
  if (dados.opcoes.incluirLubrificacao) {
    blocos.push(blocoSecao(`6.${proxima}`, 'Plano de lubrificação'));
    proxima += 1;
    const lubrificacao = itensValidos(dados.lubrificacao, ['ponto', 'produto']);
    blocos.push(...blocoTabela({
      id: 'c6-lubrificacao',
      colunas: ['PONTO', 'PRODUTO', 'QUANTIDADE', 'PERIODICIDADE'],
      linhas: lubrificacao.map((item) => [ou(item.ponto, '—'), ou(item.produto, '—'), ou(item.quantidade, '—'), ou(item.periodicidade, '—')]),
      variante: 'plano',
      larguras: ['30%', '28%', '20%', '22%'],
      alinharEsquerda: true,
      porPagina: 16,
    }));
  }

  blocos.push(blocoSecao(`6.${proxima}`, 'Limpeza'));
  proxima += 1;
  blocos.push(...blocoTexto(TEXTOS.limpezaIntro, 'c6-limpeza-intro'));
  blocos.push(...blocoLista(itensValidos(dados.limpeza, ['texto']).map((item) => item.texto), 'c6-limpeza'));

  blocos.push(blocoSecao(`6.${proxima}`, 'Lista de falhas'));
  blocos.push(...blocoTexto(TEXTOS.falhasIntro, 'c6-falhas-intro'));
  const falhas = itensValidos(dados.falhas, ['falha', 'causa', 'solucao']);
  blocos.push(...blocoTabela({
    id: 'c6-falhas',
    colunas: ['FALHA', 'CAUSA PROVÁVEL', 'SOLUÇÃO'],
    linhas: falhas.map((item) => [ou(item.falha, '—'), ou(item.causa, '—'), ou(item.solucao, '—')]),
    variante: 'plano',
    larguras: ['28%', '30%', '42%'],
    alinharEsquerda: true,
    porPagina: 15,
  }));

  return blocos;
}
